import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UuidUtilitiesService {
  public static readonly UUID_V4_REGEX = /[a-f0-9]{8}-?[a-f0-9]{4}-?4[a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}/;

  public static isUuidV4(uuid: string): boolean {
    return new RegExp(`^${this.UUID_V4_REGEX.source}$`).test(uuid);
  }
}
